export type ActionType = string;

export type ActionPayload = { [x: string]: any }

export type Action<T extends string, ActionPayload> = (ActionPayload | undefined) & {type: T}

export const createAction = function<T extends string, ActionPayload>(type: T, payload?: ActionPayload): Action<T, ActionPayload | undefined> {
	return {type, ...payload}
}